const EXERCISE_KINDS = ['exercise-edumatic', 'exercise-eduhint', 'exercise-assessmentq'];
function checkIsExercise(medialinkKind) {
    return EXERCISE_KINDS.includes(medialinkKind);
}

export { EXERCISE_KINDS, checkIsExercise };
